<div class="query-builder" [ngClass]="{ 'beta-access-enabled': isBetaAccessPrivilegeConsumable }">
  <div class="d-flex" *ngIf="qbIconReq">
    <input type="text" disabled [(ngModel)]="qbName" class="form-control form-control-sm" />
    <button
      type="button"
      class="btn clear-button btn-sm qb-button align-items-center"
      (click)="clearQueryBuilder($event)"
      *ngIf="!disableField && qbName && qbName?.length !== 0 && isDefaultFilter"
    >
      <em class="fa fa-close qb-icon"></em>
    </button>
    <button
      type="button"
      class="btn btn-sm qb-button"
      *ngIf="!disableField || (disableField && qbName && qbName?.length !== 0)"
      [ngClass]="{ contentActive: qbName && qbName?.length !== 0 }"
      (click)="toggleQueryBuilder($event)"
    >
      <em class="fa fa-code-fork qb-icon"></em>
    </button>
  </div>
</div>
<p-dialog
  header="{{ 'BUILD_CONDITION' | translate }}"
  [(visible)]="showQueryBuilder"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [style]="{ width: '85vw', height: '80vh' }"
  appendTo="body"
  [styleClass]="isBetaAccessPrivilegeConsumable ? 'query-builder-modal beta-access-enabled' : 'query-builder-modal'"
  *ngIf="showQueryBuilder"
>
  <ng-template pTemplate="header">
    <span class="dialog-header"
      >{{ this.isFromPage ? pagename : currentTableName }} - {{ 'BUILD_CONDITION' | translate }} :
      <span class="dialog-subheader">
        {{
          workflowname
            ? workflowname
            : formData?.f_fieldId
              ? formData?.f_fieldId
              : currentNode
                ? metaInfoMap[currentNode]
                : ''
        }}
      </span>
      <br />
      <span class="dialog-conditional" *ngIf="isTableLevelAcl || isButtonConditional || isWorkflowAcl">
        {{ 'TABLE_ACL_CONDITION' | translate }}</span
      >
    </span>
  </ng-template>
  <button
    type="button"
    class="copy-from p-ripple p-element p-dialog-header-icon"
    (click)="showQueriesList()"
    *ngIf="!isDefaultFilter && !disableField"
  >
    <span
      class="pi pi-copy"
      showDelay="100"
      hideDelay="100"
      pTooltip="{{ 'COPY_FROM' | translate }}"
      tooltipPosition="top"
    ></span>
  </button>

  <div class="spinner-container" [ngClass]="{ 'disable-mask': !loader.showMask }" *ngIf="showLoader">
    <p-progress-spinner></p-progress-spinner>
  </div>
  <div class="row mt-2">
    <div class="col-sm-4">
      <div class="field mb-2 d-flex row form-group pl-3">
        <label for="qbName" class="col-form-label pl-0 pb-1 pt-0 required col-sm-12">Name</label>
        <div class="pl-0 col-sm-12">
          <input
            id="qbName"
            class="form-control form-control-sm"
            type="username"
            [disabled]="disableField"
            aria-describedby="qbname-help"
            pInputText
            [(ngModel)]="qbName"
            maxlength="50"
            [ngModelOptions]="{ standalone: true }"
            required
          />

          <small *ngIf="this.message && this.message.qbName" class="input-error-text">
            <span [innerHtml]="this.message.qbName"></span>
          </small>
        </div>
      </div>
    </div>
    <div class="col-sm-8">
      <div class="field mb-2 d-flex row form-group pl-3">
        <label for="description" class="col-form-label pl-0 pb-1 pt-0 col-sm-12">Description</label>

        <textarea
          pTextarea
          id="description"
          [(ngModel)]="description"
          class="form-control form-control-sm"
          [rows]="1"
          autoResize="autoResize"
          class="col-sm-12 form-control form-control-sm"
          [disabled]="disableField"
        ></textarea>
      </div>
    </div>
  </div>
  <div class="pl-3">
    <p-tabs [(value)]="tabIndex" [ngClass]="{ 'default-filter': isDefaultFilter }">
      <p-tablist>
        <p-tab [value]="0">{{ 'QUERY' | translate }}</p-tab>
        <p-tab [value]="1">{{ 'USED_BY' | translate }}</p-tab>
      </p-tablist>

      <p-tabpanels>
        <p-tabpanel [value]="0" [selected]="true">
          <div class="qb-scroll-container">
            <div [ngClass]="{ 'def-fil': isDefaultFilter, 'dis-qb': disableField }">
              <div>
                <query-builder
                  [(ngModel)]="query"
                  [config]="config"
                  [classNames]="bootstrapClassNames"
                  [allowRuleset]="allowRuleset"
                  [allowCollapse]="allowCollapse"
                  #querybuilder
                >
                <ng-container *queryEntity="let rule; let onChange = onChange">
                  <p-select
                    #dd
                    [options]="config.entityList"
                    optionLabel="name"
                    optionValue="value"
                    placeholder="Select"
                    [appendTo]="'body'"
                    [(ngModel)]="rule.entity"
                    styleClass="lhs-entity"
                    [disabled]="disableField"
                    (onChange)="onGroupChange($event, rule); onChange(rule.entity, rule); dd.hide()"
                    style="min-width: 10rem !important"
                    *ngIf="!isDefaultFilter"
                  >
                  </p-select>
                </ng-container>

                <ng-container
                  *queryField="let rule; let fields = fields; let onChange = onChange; let getFields = getFields"
                >
                  <div class="ml-2 select-wrapper">
                    <p-select
                      #dd1
                      [options]="getTableFields(getFields, rule.entity)"
                      optionLabel="name"
                      [disabled]="disableField"
                      optionValue="value"
                      [filter]="true"
                      filterBy="name"
                      placeholder="Select Field"
                      [appendTo]="'body'"
                      [(ngModel)]="rule.field"
                      [class.errors-borders]="isRuleFieldNoLonger(rule)"
                      [class.warn-borders]="isRuleFieldMismatch(rule)"
                      [class.bor-err]="rule?.err"
                      [optionDisabled]="disabled"
                      (onChange)="onFieldCasadeChange($event, rule, fields); onChange(rule.field, rule)"
                    >
                      <ng-template let-item pTemplate="item">
                        <div
                          [ngClass]="{
                            'no-pointer-events': !item.searchable && techStack?.textSearch === 'Elastic Search'
                          }"
                        >
                          <span>{{ item.name }}</span>
                          <span *ngIf="isDefaultFilter" class="search-label">
                            {{
                              !item.searchable && techStack?.textSearch === 'Elastic Search' ? '(Not Searchable)' : ''
                            }}
                            {{
                              !item.indexed && techStack?.textSearch === 'RDBMS'
                                ? '(Not
                                                        Indexed)'
                                : ''
                            }}
                          </span>
                        </div>
                      </ng-template>
                    </p-select>
                    <span
                        *ngIf="isRuleFieldMismatch(rule)"
                        class="pi pi-exclamation-triangle warn-icon ml-1"
                        (click)="togglePopup(rule, 'warning')"
                        (keyup.enter)="togglePopup(rule, 'warning')"
                        tabindex="1"
                      ></span>
                      <span
                        *ngIf="isRuleFieldNoLonger(rule)"
                        class="pi pi-exclamation-circle errors-icon ml-1"
                        (click)="togglePopup(rule, 'error')"
                        (keyup.enter)="togglePopup(rule, 'error')"
                        tabindex="1"
                      ></span>
                      <div *ngIf="activePopupRule === rule && popupType === 'warning'" class="warning-popup">
                        <div class="popup-header">
                          <i class="pi pi-exclamation-triangle"></i>
                          Warning
                        </div>
                        <div class="popup-content">
                          {{ 'FLD_MISMATCH' | translate }}
                        </div>
                        <button class="close-btn" (click)="closePopup()">×</button>
                      </div>

                      <div *ngIf="activePopupRule === rule && popupType === 'error'" class="warning-popup-errors">
                        <div class="popup-header-errors">
                          <i class="pi pi-exclamation-circle"></i>
                          Error
                        </div>
                        <div class="popup-content-errors">
                          {{ isRuleFieldIncompatibleType(rule) ? ('FLD_INCOMPATIBLE_TYPE' | translate) : ('FLD_NO_LONGER' | translate) }}
                        </div>
                        <button class="close-btn-errors" (click)="closePopup()">×</button>
                      </div>

                    <p class="fld-err mt-1" *ngIf="rule.err">{{ rule.msg }}</p>
                  </div>
                </ng-container>

                <ng-container *queryInput="let rule; let field = field; let options = options; type: 'numberrange'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'numberrange', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; let field = field; let options = options; type: 'doublerange'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'doublerange', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; type: 'string'">
                  <ng-container
                    *ngTemplateOutlet="cascade; context: { rule: rule, config: config, type: 'string', field: field }"
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; type: 'email'">
                  <ng-container
                    *ngTemplateOutlet="cascade; context: { rule: rule, config: config, type: 'email', field: field }"
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; type: 'auto-number'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'auto-number', field: field }
                    "
                  >
                  </ng-container>
                </ng-container>

                <ng-container *queryInput="let rule; let options = options; type: 'boolean'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'boolean', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; let options = options; type: 'yes no'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'yes no', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; let options = options; let field = field; type: 'category'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'category', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; let field = field; let options = options; type: 'number'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'number', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; let field = field; let options = options; type: 'double'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'double', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; let field = field; let options = options; type: 'date'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'date', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; let field = field; let options = options; type: 'daterange'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'daterange', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; let field = field; let options = options; type: 'numberrange'">
                  numberrange
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'numberrange', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; let field = field; let options = options; type: 'timerange'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'timerange', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; let field = field; let options = options; type: 'time'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'time', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; let field = field; let options = options; type: 'multiselect'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'multiselect', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; let field = field; let options = options; type: 'role'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'role', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; let field = field; let options = options; type: 'chips'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'chips', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryInput="let rule; let field = field; let options = options; type: 'lookup'">
                  <ng-container
                    *ngTemplateOutlet="
                      cascade;
                      context: { rule: rule, config: config, type: 'lookup', field: field, options: options }
                    "
                  >
                  </ng-container>
                </ng-container>
                <ng-container *queryOperator="let rule; let operators = operators; let onChange = onChange">
                  <p-select
                    [(ngModel)]="rule.operator"
                    [options]="operators"
                    placeholder="Select"
                    styleClass="ml-5 operators"
                    [appendTo]="'body'"
                    [disabled]="disableField"
                    style="min-width: 20rem !important; max-width: 20rem !important"
                    (onChange)="onChange(rule); onOperatorChange(rule)"
                    showDelay="100"
                    hideDelay="100"
                    pTooltip="{{ rule.operator }}"
                    tooltipPosition="top"
                  >
                  </p-select>
                  <div class="d-flex align-items-center ml-5" *ngIf="rule.operator === 'is empty' && isDefaultFilter">
                    <div class="value-wid-30"></div>
                    <ng-container *ngTemplateOutlet="filterOption; context: { rule: rule }"> </ng-container>
                  </div>
                </ng-container>

                <ng-template
                  #cascade
                  let-rule="rule"
                  let-type="type"
                  let-config="config"
                  let-field="field"
                  let-options="options"
                >
                  <div class="d-flex" style="align-items: flex-end">
                    <ng-container
                      *ngIf="
                        type === 'daterange' ||
                          type === 'auto-number' ||
                          type === 'timerange' ||
                          type === 'numberrange' ||
                          type === 'doublerange';
                        then range;
                        else default
                      "
                    >
                    </ng-container>
                    <ng-template #default>
                      <ng-container *ngIf="type === 'role'; then role; else defaultType"> </ng-container>
                    </ng-template>
                    <ng-template #defaultType>
                      <div
                        class="ml-5"
                        *ngIf="rule.lhs.type !== 'time' && rule.lhs.type !== 'date'"
                        style="min-width: 10rem; max-width: 10rem"
                      >
                        <p-select
                          [options]="fieldTypes"
                          optionLabel="name"
                          optionValue="value"
                          placeholder="Select"
                          [appendTo]="'body'"
                          [(ngModel)]="rule.fieldType"
                          styleClass="field-type"
                          (onChange)="changeFieldType(rule)"
                          [disabled]="disableField"
                          style="min-width: 10rem !important"
                          showDelay="100"
                          hideDelay="100"
                          pTooltip="{{ rule.fieldType }}"
                          tooltipPosition="top"
                        >
                        </p-select>
                      </div>
                      <div
                        class="ml-5"
                        *ngIf="rule.lhs.type === 'time' || rule.lhs.type === 'date'"
                        style="min-width: 10rem; max-width: 10rem"
                      >
                        <p-select
                          [options]="datefieldTypes"
                          optionLabel="name"
                          optionValue="value"
                          placeholder="Select"
                          [appendTo]="'body'"
                          [(ngModel)]="rule.fieldType"
                          styleClass="field-type"
                          (onChange)="changeFieldType(rule)"
                          [disabled]="disableField"
                          style="min-width: 10rem !important"
                          showDelay="100"
                          hideDelay="100"
                          pTooltip="{{ rule.fieldType }}"
                          tooltipPosition="top"
                        >
                        </p-select>
                      </div>
                    </ng-template>
                    <ng-template #role>
                      <div class="ml-5" style="min-width: 10rem; max-width: 10rem">
                        <p-select
                          [options]="roleFieldTypes"
                          optionLabel="name"
                          optionValue="value"
                          placeholder="Select"
                          [appendTo]="'body'"
                          [disabled]="true"
                          [(ngModel)]="rule.fieldType"
                          styleClass="field-type"
                          (onChange)="changeFieldType(rule)"
                          style="min-width: 10rem !important"
                          showDelay="100"
                          hideDelay="100"
                          pTooltip="{{ rule.fieldType }}"
                          tooltipPosition="top"
                        >
                        </p-select>
                      </div>
                    </ng-template>
                    <ng-template #range>
                      <div
                        class="ml-5"
                        *ngIf="
                          type === 'daterange' ||
                            type === 'timerange' ||
                            type === 'numberrange' ||
                            type === 'doublerange';
                          else default
                        "
                        style="min-width: 10rem; max-width: 10rem"
                      >
                        <p-select
                          [options]="rangeFieldTypes"
                          optionLabel="name"
                          optionValue="value"
                          placeholder="Select"
                          [appendTo]="'body'"
                          [(ngModel)]="rule.fieldType"
                          styleClass="field-type"
                          [disabled]="disableField"
                          (onChange)="changeFieldType(rule)"
                          style="min-width: 10rem !important"
                          showDelay="100"
                          hideDelay="100"
                          pTooltip="{{ rule.fieldType }}"
                          tooltipPosition="top"
                        >
                        </p-select>
                      </div>
                    </ng-template>
                  </div>
                  <div class="d-flex align-items-center ml-1" *ngIf="rule.fieldType === 'pageVariable'">
                    <div [ngClass]="{ 'value-wid mr-3': isDefaultFilter }">
                      <p-select
                        [options]="rule.fieldOptions"
                        optionLabel="name"
                        optionValue="value"
                        [class.bor-err]="rule?.err"
                        placeholder="Select"
                        [appendTo]="'body'"
                        [disabled]="disableField"
                        [(ngModel)]="rule.rhs.value"
                      >
                      </p-select>
                    </div>
                  </div>

                  <div
                    class="d-flex align-items-center ml-1"
                    style="margin-top: -4px !important"
                    *ngIf="rule.fieldType === 'plusDays' || rule.fieldType === 'minusDays'"
                  >
                    <div [ngClass]="{ 'value-wid mr-3': isDefaultFilter }">
                      <p-inputNumber
                        [(ngModel)]="rule.rhs.value"
                        [min]="0"
                        maxlength="6"
                        [useGrouping]="false"
                        mode="decimal"
                        [class.bor-err]="rule?.err"
                        class="form-control form-control-sm"
                      ></p-inputNumber>
                    </div>
                  </div>
                  <div class="d-flex align-items-center ml-1" *ngIf="rule.fieldType === 'value'">
                    <div [ngClass]="{ 'value-wid mr-3': isDefaultFilter }">
                      <ng-container [ngSwitch]="type">
                        <ng-template [ngSwitchCase]="'string'">
                          <input
                            type="text"
                            pInputText
                            [(ngModel)]="rule.rhs.value"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                          />
                        </ng-template>
                        <ng-template [ngSwitchCase]="'email'">
                          <input
                            type="text"
                            pInputText
                            [(ngModel)]="rule.rhs.value"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                          />
                        </ng-template>
                        <ng-template [ngSwitchCase]="'lookup'">
                          <input
                            type="text"
                            pInputText
                            [(ngModel)]="rule.rhs.value"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                          />
                        </ng-template>
                        <ng-template [ngSwitchCase]="'boolean'">
                          <p-select
                            [options]="options"
                            optionLabel="name"
                            optionValue="value"
                            [class.bor-err]="rule?.err"
                            placeholder="Select"
                            [appendTo]="'body'"
                            [disabled]="disableField"
                            [(ngModel)]="rule.rhs.value"
                          >
                          </p-select>
                        </ng-template>
                        <ng-template [ngSwitchCase]="'yes no'">
                          <p-select
                            [options]="options"
                            optionLabel="name"
                            optionValue="value"
                            [class.bor-err]="rule?.err"
                            placeholder="Select"
                            [appendTo]="'body'"
                            [disabled]="disableField"
                            [(ngModel)]="rule.rhs.value"
                          >
                          </p-select>
                        </ng-template>
                        <ng-template [ngSwitchCase]="'category'">
                          <div class="dropdown-with-error-wrapper">
                            <p-select
                              [showClear]="true"
                              [options]="options"
                              optionLabel="name"
                              [class.bor-err]="rule?.err"
                              optionValue="value"
                              placeholder="Select"
                              [appendTo]="'body'"
                              [disabled]="disableField"
                              [(ngModel)]="rule.rhs.value"
                              [class.errors-borders]="isRhsOptionNoLonger(rule)"
                            >
                            </p-select>
                            <span
                              *ngIf="isRhsOptionNoLonger(rule)"
                              class="pi pi-exclamation-circle rhs-errors-icon-inside"
                              (click)="toggleRhsPopup(rule, 'error'); $event.stopPropagation()"
                              (keyup.enter)="toggleRhsPopup(rule, 'error')"
                              tabindex="1"
                            ></span>
                            <div *ngIf="activeRhsPopupRule === rule && rhsPopupType === 'error'" class="rhs-warning-popup-errors">
                              <div class="popup-header-errors">
                                <i class="pi pi-exclamation-circle"></i>
                                Error
                              </div>
                              <div class="popup-content-errors">
                                {{ 'RHS_OPTION_NO_LONGER' | translate }}
                              </div>
                              <button class="close-btn-errors" (click)="closeRhsPopup()">×</button>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template [ngSwitchCase]="'date'">
                          <p-datepicker
                            [(ngModel)]="rule.rhs.value"
                            dateFormat="dd/mm/yy"
                            [class.bor-err]="rule?.err"
                            [appendTo]="'body'"
                            [showTime]="false"
                            [disabled]="disableField"
                            (onSelect)="onSelectDateValue($event, rule.rhs.value)"
                          >
                          </p-datepicker>
                        </ng-template>
                        <ng-template [ngSwitchCase]="'time'">
                          <p-datepicker
                            [(ngModel)]="rule.rhs.value"
                            dateFormat="dd/mm/yy"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                            [showTime]="true"
                            [appendTo]="'body'"
                            [showSeconds]="true"
                          >
                          </p-datepicker>
                        </ng-template>
                        <ng-template [ngSwitchCase]="'number'">
                          <p-inputNumber
                            [(ngModel)]="rule.rhs.value"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                          >
                          </p-inputNumber>
                        </ng-template>
                        <ng-template [ngSwitchCase]="'auto-number'">
                          <p-inputNumber
                            [(ngModel)]="rule.rhs.value"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                          >
                          </p-inputNumber>
                        </ng-template>
                        <ng-template [ngSwitchCase]="'double'">
                          <p-inputNumber
                            [(ngModel)]="rule.rhs.value"
                            mode="decimal"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                            [minFractionDigits]="rule.minFrac"
                            [maxFractionDigits]="rule.maxFrac"
                          ></p-inputNumber>
                        </ng-template>
                        <ng-template [ngSwitchCase]="'multiselect'">
                          <p-multiselect
                            resetFilterOnHide="true"
                            [options]="options"
                            [class.bor-err]="rule?.err"
                            [maxSelectedLabels]="2"
                            selectedItemsLabel="{0} items selected"
                            [(ngModel)]="rule.rhs.value"
                            defaultLabel="Select"
                            [disabled]="disableField"
                            optionLabel="name"
                            placeholder="Select"
                            optionValue="value"
                            [appendTo]="'body'"
                          >
                          </p-multiselect>
                        </ng-template>
                        <ng-template [ngSwitchCase]="'role'">
                          <p-multiselect
                            resetFilterOnHide="true"
                            [options]="options"
                            [class.bor-err]="rule?.err"
                            [maxSelectedLabels]="2"
                            selectedItemsLabel="{0} items selected"
                            [(ngModel)]="rule.rhs.value"
                            defaultLabel="Select"
                            [disabled]="disableField"
                            optionLabel="name"
                            placeholder="Select"
                            optionValue="value"
                            [appendTo]="'body'"
                          >
                          </p-multiselect>
                        </ng-template>
                        <ng-template [ngSwitchCase]="'chips'">
                          <div class="chips-wrapper d-flex flex-column">
                            <span class="sub-text">{{ 'P_CHIP_MESSAGE' | translate }}</span>
                            <p-chips
                              [(ngModel)]="rule.rhs.value"
                              separator=","
                              [class.bor-err]="rule?.err"
                              (onAdd)="handleChipAdd($event, rule)"
                              [disabled]="disableField"
                            ></p-chips>
                          </div>
                        </ng-template>
                      </ng-container>
                    </div>
                    <ng-container *ngIf="isDefaultFilter">
                      <ng-container *ngTemplateOutlet="filterOption; context: { rule: rule }"> </ng-container>
                    </ng-container>
                  </div>
                  <div class="d-flex align-items-center ml-1" *ngIf="rule.fieldType === 'custom'">
                    <div class="value-wid mr-3"></div>
                    <ng-container *ngTemplateOutlet="filterOption; context: { rule: rule }"> </ng-container>
                  </div>
                  <div
                    class="d-flex align-items-center ml-1"
                    *ngIf="(!rule.fieldType || rule.fieldType === 'empty') && isDefaultFilter"
                  >
                    <ng-container *ngTemplateOutlet="filterOption; context: { rule: rule }"> </ng-container>
                  </div>
                  <div class="d-flex align-items-center ml-1" *ngIf="rule.fieldType === 'field'">
                    <p-select
                      [showClear]="true"
                      [options]="config.entityList"
                      optionLabel="name"
                      [class.bor-err]="rule?.err"
                      optionValue="value"
                      placeholder="Select Table"
                      [appendTo]="'body'"
                      [disabled]="disableField"
                      [(ngModel)]="rule.rhs.tableId"
                      (onChange)="onInputGroupChange($event, rule)"
                      [tooltip]="name"
                      [tooltipPosition]="'top'"
                      [filter]="true"
                      filterBy="name"
                      [ngClass]="{ 'no-pointer-events': config.entityList?.length === 1 }"
                    >
                    </p-select>
                    <p-select
                      [showClear]="true"
                      [options]="getEntityFields(rule.rhs.tableId, rule)"
                      [class.bor-err]="rule?.err"
                      optionLabel="name"
                      optionValue="value"
                      placeholder="Select Field"
                      [disabled]="disableField"
                      [appendTo]="'body'"
                      [(ngModel)]="rule.rhs.fieldId"
                      class="ml-2"
                      [tooltip]="name"
                      [filter]="true"
                      filterBy="name"
                    >
                    </p-select>
                  </div>

                  <div *ngIf="rule.fieldType === 'fields'" class="d-flex align-items-center ml-1">
                    <div class="d-flex align-items-center">
                      <p-select
                        [showClear]="true"
                        [options]="config.entityList"
                        optionLabel="name"
                        [class.bor-err]="rule?.err"
                        optionValue="value"
                        placeholder="Select Table"
                        [appendTo]="'body'"
                        [disabled]="disableField"
                        [(ngModel)]="rule.rhs.from.tableId"
                        (onChange)="onInputGroupChange($event, rule)"
                        [tooltip]="name"
                        [filter]="true"
                        filterBy="name"
                      >
                      </p-select>
                      <p-select
                        [showClear]="true"
                        [options]="getEntityFields(rule.rhs.from.tableId, rule)"
                        optionLabel="name"
                        [class.bor-err]="rule?.err"
                        optionValue="value"
                        placeholder="Select Field"
                        [appendTo]="'body'"
                        [disabled]="disableField"
                        [(ngModel)]="rule.rhs.from.fieldId"
                        class="ml-2"
                        [tooltip]="name"
                        [filter]="true"
                        filterBy="name"
                      >
                      </p-select>
                      <p class="field-name mb-0 ml-2">and</p>
                      <p-select
                        [showClear]="true"
                        [options]="config.entityList"
                        optionLabel="name"
                        [class.bor-err]="rule?.err"
                        optionValue="value"
                        placeholder="Select Table"
                        [appendTo]="'body'"
                        [disabled]="disableField"
                        [(ngModel)]="rule.rhs.to.tableId"
                        class="ml-2"
                        (onChange)="onToInputGroupChange($event, rule)"
                        [tooltip]="name"
                        [filter]="true"
                        filterBy="name"
                      >
                      </p-select>
                      <p-select
                        [showClear]="true"
                        [options]="getEntityFields(rule.rhs.to.tableId, rule)"
                        optionLabel="name"
                        [class.bor-err]="rule?.err"
                        optionValue="value"
                        placeholder="Select Field"
                        [appendTo]="'body'"
                        [disabled]="disableField"
                        [(ngModel)]="rule.rhs.to.fieldId"
                        class="ml-2"
                        [tooltip]="name"
                        [filter]="true"
                        filterBy="name"
                      >
                      </p-select>
                    </div>
                  </div>

                  <div *ngIf="rule.fieldType === 'values'" class="d-flex align-items-center ml-1">
                    <div
                      [ngClass]="{
                        'values-wid mr-3': isDefaultFilter && type !== 'timerange',
                        'timerange-values-wid mr-3': isDefaultFilter && type === 'timerange'
                      }"
                    >
                      <ng-container [ngSwitch]="type">
                        <ng-template [ngSwitchCase]="'daterange'">
                          <div class="d-flex align-items-center">
                            <p-datepicker
                              [(ngModel)]="rule.rhs.from.value"
                              dateFormat="dd/mm/yy"
                              [class.bor-err]="rule?.err"
                              [disabled]="disableField"
                              [appendTo]="'body'"
                            >
                            </p-datepicker>
                            <p class="field-name mb-0 ml-2">and</p>
                            <p-datepicker
                              class="ml-2"
                              [(ngModel)]="rule.rhs.to.value"
                              [class.bor-err]="rule?.err"
                              dateFormat="dd/mm/yy"
                              [appendTo]="'body'"
                              [disabled]="disableField"
                              [minDate]="rule.rhs.from.value"
                            >
                            </p-datepicker>
                          </div>
                        </ng-template>
                        <ng-template [ngSwitchCase]="'timerange'">
                          <div class="d-flex align-items-center">
                            <p-datepicker
                              [(ngModel)]="rule.rhs.from.value"
                              dateFormat="dd/mm/yy"
                              [class.bor-err]="rule?.err"
                              [disabled]="disableField"
                              [showTime]="true"
                              [appendTo]="'body'"
                              [showSeconds]="true"
                            ></p-datepicker>
                            <p class="field-name mb-0 ml-2">and</p>
                            <p-datepicker
                              class="ml-2"
                              [(ngModel)]="rule.rhs.to.value"
                              [class.bor-err]="rule?.err"
                              [disabled]="disableField"
                              dateFormat="dd/mm/yy"
                              [showTime]="true"
                              [appendTo]="'body'"
                              [showSeconds]="true"
                              [minDate]="rule.rhs.from.value"
                            ></p-datepicker>
                          </div>
                        </ng-template>
                        <ng-template [ngSwitchCase]="'numberrange'">
                          <div class="d-flex align-items-center">
                            <p-inputNumber
                              [(ngModel)]="rule.rhs.from.value"
                              [class.bor-err]="rule?.err"
                              [disabled]="disableField"
                            ></p-inputNumber>
                            <p class="field-name mb-0 ml-2">and</p>
                            <p-inputNumber
                              class="ml-2"
                              [(ngModel)]="rule.rhs.to.value"
                              [class.bor-err]="rule?.err"
                              [disabled]="disableField"
                            >
                            </p-inputNumber>
                          </div>
                        </ng-template>
                        <ng-template [ngSwitchCase]="'doublerange'">
                          <div class="d-flex align-items-center">
                            <p-inputNumber
                              [(ngModel)]="rule.rhs.from.value"
                              mode="decimal"
                              [class.bor-err]="rule?.err"
                              [disabled]="disableField"
                              [minFractionDigits]="rule.minFrac"
                              [maxFractionDigits]="rule.maxFrac"
                            ></p-inputNumber>
                            <p class="field-name mb-0 ml-2">and</p>
                            <p-inputNumber
                              class="ml-2"
                              [(ngModel)]="rule.rhs.to.value"
                              [class.bor-err]="rule?.err"
                              [disabled]="disableField"
                              mode="decimal"
                              [minFractionDigits]="rule.minFrac"
                              [maxFractionDigits]="rule.maxFrac"
                            >
                            </p-inputNumber>
                          </div>
                        </ng-template>
                      </ng-container>
                    </div>
                    <ng-container *ngTemplateOutlet="filterOption; context: { rule: rule }"> </ng-container>
                  </div>

                  <div class="align-items-center ml-5" *ngIf="rule.fieldType === 'field and value'">
                    <ng-container [ngSwitch]="type">
                      <ng-template [ngSwitchCase]="'daterange'">
                        <div class="d-flex align-items-center">
                          <p-select
                            [showClear]="true"
                            [options]="config.entityList"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select Table"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.from.tableId"
                            [filter]="true"
                            filterBy="name"
                          >
                          </p-select>
                          <p-select
                            [showClear]="true"
                            [disabled]="disableField"
                            [class.bor-err]="rule?.err"
                            [options]="getEntityFields(rule.rhs.from.tableId, rule)"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select Field"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.from.fieldId"
                            class="ml-2"
                            [filter]="true"
                            filterBy="name"
                          >
                          </p-select>
                          <p class="field-name mb-0 ml-2">and</p>
                          <p-datepicker
                            class="ml-2"
                            [(ngModel)]="rule.rhs.to.value"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                            dateFormat="dd/mm/yy"
                            [appendTo]="'body'"
                          >
                          </p-datepicker>
                        </div>
                      </ng-template>
                      <ng-template [ngSwitchCase]="'numberrange'">
                        <div class="d-flex align-items-center">
                          <p-select
                            [showClear]="true"
                            [options]="config.entityList"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select Table"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.from.tableId"
                            [filter]="true"
                            filterBy="name"
                          >
                          </p-select>
                          <p-select
                            [showClear]="true"
                            [disabled]="disableField"
                            [class.bor-err]="rule?.err"
                            [options]="getEntityFields(rule.rhs.from.tableId, rule)"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select Field"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.from.fieldId"
                            class="ml-2"
                            [filter]="true"
                            filterBy="name"
                          >
                          </p-select>
                          <p class="field-name mb-0 ml-2">and</p>
                          <p-inputNumber
                            class="ml-2"
                            [(ngModel)]="rule.rhs.to.value"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                          >
                          </p-inputNumber>
                        </div>
                      </ng-template>
                      <ng-template [ngSwitchCase]="'doublerange'">
                        <div class="d-flex align-items-center">
                          <p-select
                            [showClear]="true"
                            [options]="config.entityList"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select Table"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.from.tableId"
                            [filter]="true"
                            filterBy="name"
                          >
                          </p-select>
                          <p-select
                            [showClear]="true"
                            [disabled]="disableField"
                            [class.bor-err]="rule?.err"
                            [options]="getEntityFields(rule.rhs.from.tableId, rule)"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select Field"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.from.fieldId"
                            class="ml-2"
                            [filter]="true"
                            filterBy="name"
                          >
                          </p-select>
                          <p class="field-name mb-0 ml-2">and</p>
                          <p-inputNumber
                            class="ml-2"
                            [(ngModel)]="rule.rhs.to.value"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                            mode="decimal"
                            [minFractionDigits]="rule.minFrac"
                            [maxFractionDigits]="rule.maxFrac"
                          >
                          </p-inputNumber>
                        </div>
                      </ng-template>
                      <ng-template [ngSwitchCase]="'timerange'">
                        <div class="d-flex align-items-center">
                          <p-select
                            [showClear]="true"
                            [options]="config.entityList"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select Table"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.from.tableId"
                            [filter]="true"
                            filterBy="name"
                          >
                          </p-select>
                          <p-select
                            [showClear]="true"
                            [disabled]="disableField"
                            [class.bor-err]="rule?.err"
                            [options]="getEntityFields(rule.rhs.from.tableId, rule)"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select Field"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.from.fieldId"
                            class="ml-2"
                            [filter]="true"
                            filterBy="name"
                          >
                          </p-select>
                          <p class="field-name mb-0 ml-2">and</p>
                          <p-datepicker
                            class="ml-2"
                            [(ngModel)]="rule.rhs.to.value"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                            dateFormat="dd/mm/yy"
                            [showTime]="true"
                            [appendTo]="'body'"
                            [showSeconds]="true"
                          ></p-datepicker>
                        </div>
                      </ng-template>
                    </ng-container>
                  </div>

                  <div class="align-items-center ml-5" *ngIf="rule.fieldType === 'value and field'">
                    <ng-container [ngSwitch]="type">
                      <ng-template [ngSwitchCase]="'daterange'">
                        <div class="d-flex align-items-center">
                          <p-datepicker
                            [(ngModel)]="rule.rhs.from.value"
                            dateFormat="dd/mm/yy"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                            [appendTo]="'body'"
                          >
                          </p-datepicker>
                          <p class="field-name mb-0 ml-2">and</p>
                          <p-select
                            [showClear]="true"
                            [options]="config.entityList"
                            [disabled]="disableField"
                            optionLabel="name"
                            optionValue="value"
                            [class.bor-err]="rule?.err"
                            placeholder="Select Table"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.to.tableId"
                            class="ml-2"
                          >
                            class="ml-2" [filter]="true" filterBy="name">
                          </p-select>
                          <p-select
                            [showClear]="true"
                            [disabled]="disableField"
                            [class.bor-err]="rule?.err"
                            [options]="getEntityFields(rule.rhs.to.tableId, rule)"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select Field"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.to.fieldId"
                            class="ml-2"
                            [filter]="true"
                            filterBy="name"
                          >
                          </p-select>
                        </div>
                      </ng-template>
                      <ng-template [ngSwitchCase]="'numberrange'">
                        <div class="d-flex align-items-center">
                          <p-inputNumber
                            [(ngModel)]="rule.rhs.from.value"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                          >
                          </p-inputNumber>
                          <p class="field-name mb-0 ml-2">and</p>
                          <p-select
                            [showClear]="true"
                            [options]="config.entityList"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select Table"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.to.tableId"
                            class="ml-2"
                            [filter]="true"
                            filterBy="name"
                          >
                          </p-select>
                          <p-select
                            [showClear]="true"
                            [options]="getEntityFields(rule.rhs.to.tableId, rule)"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select Field"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.to.fieldId"
                            class="ml-2"
                            [filter]="true"
                            filterBy="name"
                          >
                          </p-select>
                        </div>
                      </ng-template>
                      <ng-template [ngSwitchCase]="'doublerange'">
                        <div class="d-flex align-items-center">
                          <p-inputNumber
                            [(ngModel)]="rule.rhs.from.value"
                            mode="decimal"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                            [minFractionDigits]="rule.minFrac"
                            [maxFractionDigits]="rule.maxFrac"
                          >
                          </p-inputNumber>
                          <p class="field-name mb-0 ml-2">and</p>
                          <p-select
                            [showClear]="true"
                            [options]="config.entityList"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select Table"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.to.tableId"
                            class="ml-2"
                            [filter]="true"
                            filterBy="name"
                          >
                          </p-select>
                          <p-select
                            [showClear]="true"
                            [disabled]="disableField"
                            [class.bor-err]="rule?.err"
                            [options]="getEntityFields(rule.rhs.to.tableId, rule)"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select Field"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.to.fieldId"
                            class="ml-2"
                            [filter]="true"
                            filterBy="name"
                          >
                          </p-select>
                        </div>
                      </ng-template>
                      <ng-template [ngSwitchCase]="'timerange'">
                        <div class="d-flex align-items-center">
                          <p-datepicker
                            [(ngModel)]="rule.rhs.from.value"
                            dateFormat="dd/mm/yy"
                            [class.bor-err]="rule?.err"
                            [showTime]="true"
                            [appendTo]="'body'"
                            [disabled]="disableField"
                            [showSeconds]="true"
                          ></p-datepicker>
                          <p class="field-name mb-0 ml-2">and</p>
                          <p-select
                            [showClear]="true"
                            [options]="config.entityList"
                            [class.bor-err]="rule?.err"
                            [disabled]="disableField"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select Table"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.to.tableId"
                            class="ml-2"
                            [filter]="true"
                            filterBy="name"
                          >
                          </p-select>
                          <p-select
                            [showClear]="true"
                            [class.bor-err]="rule?.err"
                            [options]="getEntityFields(rule.rhs.to.tableId, rule)"
                            [disabled]="disableField"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="Select Field"
                            [appendTo]="'body'"
                            [(ngModel)]="rule.rhs.to.fieldId"
                            class="ml-2"
                            [filter]="true"
                            filterBy="name"
                          >
                          </p-select>
                        </div>
                      </ng-template>
                    </ng-container>
                  </div>
                </ng-template>
              </query-builder>
            </div>
          </div>
          </div>
        </p-tabpanel>
        <p-tabpanel [value]="1" *ngIf="isQueryExists" [disabled]="!isExist || !references">
          <p-table
            [columns]="referencesCol"
            [value]="references"
            dataKey="sid"
            responsiveLayout="scroll"
            styleClass="p-datatable-sm eva-v2-table-container"
            id="add_key_table"
          >
            <ng-template #header let-columns>
              <tr>
                <th *ngFor="let col of columns">
                  {{ col.header | translate }}
                </th>
              </tr>
            </ng-template>
            <ng-template #body let-rowData let-columns="columns" let-rowIndex="rowIndex">
              <tr>
                <td *ngFor="let col of columns">
                  {{ rowData[col.field] }}
                </td>
              </tr>
            </ng-template>
            <ng-template #emptymessage let-columns>
              <tr class="no-records">
                <td colspan="6" class="text-center">
                  {{ 'NO_RECORDS_FOUND' | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
  <ng-template pTemplate="footer">
    <button
      type="button"
      class="btn btn-secondary cancel-btn btn-sm border-left-0 clear-btn"
      [ngClass]="{ 'button-outlined': isBetaAccessPrivilegeConsumable }"
      (click)="clearQuery()"
      [disabled]="disableField || isQueryEmpty"
    >
      {{ 'CLEAR' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary cancel-btn"
      [ngClass]="{ 'button-outlined': isBetaAccessPrivilegeConsumable }"
      (click)="confirmCancel(); cancelQb()"
    >
      {{ 'CANCEL' | translate }}
    </button>
	<button
		type="button"
		class="btn btn-primary btn-sm px-3 save-btn "
		[ngClass]="{ 'button-filled': isBetaAccessPrivilegeConsumable }"
		(click)="saveQuery()"
		[disabled]="disableField"
	>
		{{ 'SAVE' | translate }}
	</button>
    <button
      type="button"
      class="btn btn-primary btn-sm px-3 save-as-new-btn"
      [ngClass]="{ 'button-filled': isBetaAccessPrivilegeConsumable }"
      [disabled]="disableField"
      (click)="saveQuery(true)"
      *ngIf="isExist && !isDefaultFilter"
      showDelay="100"
      hideDelay="100"
      pTooltip="{{ 'Please change the query name if it is not done.' | translate }}"
      tooltipPosition="top"
    >
      {{ 'SAVE_AS_NEW' | translate }}
    </button>
    
  </ng-template>
</p-dialog>

<p-dialog
  header="{{ 'COPY_FROM' | translate }}"
  [(visible)]="showQueries"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '70vw' }"
  appendTo="body"
  styleClass="queries-modal"
  *ngIf="showQueries"
>
  <div class="search-form-control field-filter">
    <span class="search-icon">
      <i class="pi pi-search"></i>
    </span>
    <input
      type="text"
      class="form-control form-control-sm"
      placeholder="Search"
      [(ngModel)]="searchTerm"
      name="searchTerm"
      [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
      #fieldFilter
    />
  </div>
  <div class="section-table-container">
    <p-table
      [columns]="addQueryCols"
      [value]="allQueries | uiFilter: searchTerm : ['queryName', 'property', 'queryDescription', 'fieldName']"
      dataKey="sid"
      responsiveLayout="scroll"
      styleClass="p-datatable-sm eva-v2-table-container"
      id="add_key_table"
      [(selection)]="selectedQuery"
    >
      <ng-template #header let-columns>
        <tr>
          <th></th>
          <th *ngFor="let col of columns">
            {{ col.header | translate }}
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-rowData let-columns="columns" let-rowIndex="rowIndex">
        <tr>
          <td>
            <p-tableRadioButton [value]="rowData"></p-tableRadioButton>
          </td>
          <ng-container *ngFor="let col of columns">
            <ng-container *ngIf="col.field === 'queryName'">
              <!-- Regular td for queryName -->
              <td>{{ rowData[col.field] }}</td>
            </ng-container>
            <ng-container *ngIf="col.field === 'queryDescription'">
              <!-- Textarea for queryDescription -->
              <td>
                <textarea
                  pTextarea
                  id="description"
                  [(ngModel)]="rowData[col.field]"
                  class="form-control form-control-sm"
                  [rows]="1"
                  autoResize="autoResize"
                  class="col-sm-12 form-control form-control-sm"
                  [disabled]="true"
                ></textarea>
              </td>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template #emptymessage let-columns>
        <tr class="no-records">
          <td colspan="3" class="text-center">
            {{ 'NO_RECORDS_FOUND' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div *ngIf="isPopupLoader" class="d-flex justify-content-center align-items-center w-100">
    <div class="spinners">
      <p-progress-spinner></p-progress-spinner>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary cancel-btn" (click)="onCloseQb()">
      {{ 'CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="updateQuery()">{{ 'COPY' | translate }}</button>
  </ng-template>
</p-dialog>

<p-dialog
  header="{{ 'FILTER_OPTIONS' | translate }}"
  [(visible)]="showFilterOptions"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '50vw' }"
  appendTo="body"
  *ngIf="showFilterOptions"
  [closable]="true"
  styleClass="filter-ops-model"
>
  <div class="p-3">
    <div class="d-flex align-items-center mb-2">
      <p-checkbox binary="true" inputId="allowView" [(ngModel)]="allowView" (onChange)="UpdateRule($event)">
      </p-checkbox>
      <label class="mb-0 pl-1 pt-0 cursor-pointer opt-lbl" for="allowView"
        >{{ 'ALLOW_VIEW' | translate }}
        <i
          class="fa fa-info-circle field-info"
          showDelay="100"
          hideDelay="100"
          tooltipPosition="bottom"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="{{ 'ALLOW_VIEW_INFO' | translate }}"
        ></i>
      </label>
    </div>
    <div class="d-flex align-items-center mb-2">
      <p-checkbox
        binary="true"
        inputId="allowEdit"
        [(ngModel)]="allowEdit"
        (onChange)="UpdateRule($event)"
        [disabled]="!allowView"
      ></p-checkbox>
      <label class="mb-0 pl-1 pt-0 cursor-pointer opt-lbl" for="allowEdit"
        >{{ 'ALLOW_EDIT' | translate }}
        <i
          class="fa fa-info-circle field-info"
          showDelay="100"
          hideDelay="100"
          tooltipPosition="bottom"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="{{ 'ALLOW_EDIT_INFO' | translate }}"
        ></i>
      </label>
    </div>
    <div class="d-flex align-items-center mb-1">
      <p-checkbox
        binary="true"
        inputId="holdValue"
        [(ngModel)]="holdValue"
        (onChange)="UpdateRule($event)"
        [disabled]="holdValDis"
      ></p-checkbox>
      <label class="mb-0 pl-1 pt-0 cursor-pointer opt-lbl" for="holdValue"
        >{{ 'HOLD_VALUE' | translate }}
        <i
          class="fa fa-info-circle field-info"
          showDelay="100"
          hideDelay="100"
          tooltipPosition="bottom"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="{{ 'HOLD_VAL_INFO' | translate }}"
        ></i>
      </label>
    </div>
  </div>
</p-dialog>
